// extracted by mini-css-extract-plugin
export default {"description":"_9lNuo9T8Llk4fEIAc6zrc","detail":"_4KgspyEAkbZz2afPzmW4a5","mapContainer":"_4dHQzcjWchxSKwpLzmLYab","map":"_2tveMdf2wadEpyJJhonQPc","address":"_5aqFfKzYjt7w9CNT8UZSdv"};